module.exports = __webpack_public_path__ + "catalog/items/bathroom/Circular-sink/Circular-sink.svg";